import { BridgeFiatRail } from 'services/merchants/types';
import { Payout } from 'services/payouts/types';

import i18n from 'locales/i18next';

import { CurrencyCode } from 'types/currency';

import { formatNumberI18n } from 'utils/i18n';

import { LABELS } from './keys';
import { PayoutDataRow } from './types';

export const transformPayoutsDataToTableFormat = (payouts?: Payout[]): PayoutDataRow[] => {
  return payouts
    ? payouts.map((payout) => ({
        ...payout,
        amount: payout.payoutNetAmount ?? payout.amount,
        id: payout.uuid,
      }))
    : [];
};
export const formatNumber = (stringOrNumber?: string | number) => formatNumberI18n(i18n.language)(Number(stringOrNumber ?? 0));

interface PayoutThresholdMessageParams {
  currency: CurrencyCode;
  minAmount: number;
  nextPayoutAmount?: string;
  paymentRail?: BridgeFiatRail;
}

export const getPayoutThresholdMessage = ({
  currency,
  minAmount,
  nextPayoutAmount,
  paymentRail,
}: PayoutThresholdMessageParams): string | null => {
  if (!nextPayoutAmount || !paymentRail) {
    return null;
  }

  const numericBalance = parseFloat(nextPayoutAmount);

  if (numericBalance < minAmount && minAmount > 0) {
    const formattedMin = new Intl.NumberFormat(i18n.language, {
      style: 'currency',
      currency,
    }).format(minAmount);

    return i18n.t(LABELS.MERCHANT_INFO.PAYOUT_THRESHOLD_MESSAGE, {
      rail: paymentRail.toUpperCase(),
      amount: formattedMin,
    });
  }

  return null;
};
